<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="">会员中心</router-link></li>
                <li class="currentNode"><a>我的驻京美食</a></li>
            </ul>
            <div class="page-main">
                <person-center-menu></person-center-menu>
                <div class="page-content">
                    <h3>
                        <span>我的驻京美食</span>
                        <button class="addUpload" @click="goUpload()"><i class="el-icon-circle-plus"></i>添加</button>
                    </h3>
                    <el-divider></el-divider>
                    <el-table
                        class="theadTable"
                        :data="tableData">
                        <el-table-column
                            label="ID"
                            width="80"
                            prop="Id">
                        </el-table-column>
                        <el-table-column
                            label="店铺名称"
                            min-width="100"
                            prop="Title">
                        </el-table-column>
                        <el-table-column
                            prop="SubTitle"
                            label="标签"
                            min-width="150">
                        </el-table-column>
                        <el-table-column
                            label="人均价格"
                            width="120"
                            prop="AvgPrice">
                        </el-table-column>
                        <el-table-column
                            label="状态"
                            width="100">
                            <template slot-scope="scope">
                                {{ scope.row.Status | checkStatus}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="120">
                            <template slot-scope="scope">
                                <el-button class="textBtn" @click="goRecommendFood(scope.row)" type="text" size="small"  v-if="scope.row.Status == '10'">推荐菜</el-button>
                                <el-button class="textBtn" @click="goReason(scope.row)" type="text" size="small" v-if="scope.row.Status == '-10'">查看原因</el-button>
                                <el-button class="textBtn" @click="goEdit(scope.row)" type="text" size="small">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :pageSize="pageSize"
                    @current-change="handleCurrentChange">
                </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PersonCenterMenu from '@/components/personCenterMenu.vue'
import {
    baseUrl,
    getMyFoodShop,
    dddFengcai
} from '@services/tokenService.js';
import { getCookie } from '@/assets/utils/cookie.js'
export default {
    name: '',
    components: { PersonCenterMenu },
    data() {
        return {
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
        };
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
        companyId() {
            return this.$store.state.permission.companyId;
        },
    },
    created() {
        if (this.accountId === '') {
            this.$router.push(
                {
                    path: '/layout/login',
                }
            );
        } 
        this.getMyFoodShop();
    },
    methods: {
        getMyFoodShop() {
            let params = {
                companyid: this.companyId,
                current: this.currentPage,
                size: this.pageSize,
            };
            getMyFoodShop(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.tableData = res.Data;
                    this.total = res.Count;
                } else {
                    this.$message.error("我的驻京美食请求失败");
                }
            })
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getMyFoodShop();
        },
        goRecommendFood(row) {
            this.$router.push(
                {
                    path:'/layout/recommend-food',
                    query: {
                        id: row.Id,
                    }
                }
            );
        },
        goUpload() {
            this.$router.push(
                {
                    path:'/layout/upload-food',
                }
            );
        },
        goReason(data) {
            this.$alert('内容', '原因', {
                confirmButtonText: '确定',
                callback: action => {
                    
                }
            });
        },
        goEdit(data) {
            this.$router.push(
                {
                    path:'/layout/upload-food',
                    query: {
                        id: data.Id,
                    }
                }
            );
        },
        deleteData(data) {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
    },
    filters: {
        checkStatus(values) {
            if (values === null) {
                return '';
            }
            let checkStatusList = [
                {
                    label: '审核通过',
                    value: '10'
                },
                {
                    label: '审核失败',
                    value: '-10'
                },
                {
                    label: '待审核',
                    value: '0'
                },
            ];
            for(let i=0;i<checkStatusList.length;i++) {
                if (checkStatusList[i].value == values) {
                    return checkStatusList[i].label;
                }
            }
            return '';
        }
    }
};
</script>

<style scoped>
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: left;
    margin-bottom: 0;
    padding-bottom: 0;
    display:flex;
    justify-content: space-between;
    align-items: center;
}
.theadTable {
    box-shadow: -2px -2px 16px 1px #00000026;
    margin-bottom: 30px;
}
.vertical-nav li a.active {
    border-left: none;
}
.textBtn {
    color: #2e8cd8;
}
</style>